import { render, staticRenderFns } from "./VersionModal.vue?vue&type=template&id=4e56ce3e&scoped=true&"
import script from "./VersionModal.vue?vue&type=script&lang=js&"
export * from "./VersionModal.vue?vue&type=script&lang=js&"
import style0 from "./VersionModal.vue?vue&type=style&index=0&id=4e56ce3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e56ce3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VDialog,
})
